<template>
	<div>
		<div class="cate">
			<el-row v-if="!keyword">
				<el-col :span="8" v-for="(item,index) in cate" :key="index">
					<div class="cate-name" :class="current ==index?'active':''" @click="change(index)">
						{{item.cate_name}}</div>
				</el-col>
			</el-row>

			<el-row v-else>
				<el-col :span="8" >
					<div class="cate-name active" >搜索列表</div>
				</el-col>
			</el-row>
		</div>

		<div class="cate-image" v-if="cate.length && !keyword">
			<img :src="cate[current].cate_image">
		</div>

		<div class="act-list">
			<el-row  :gutter="20">
				<el-col :span="8" v-for="(item,index) in list" :key="index">
					<div class="act-content">
						<div class="act-image">
							<img :src="item.act_image">
						</div>
						<div class="act-info">
							<div class="act-name">{{item.act_name}}</div>
							<div class="act-time">时间：{{item.act_start_time}} - {{item.act_end_time}}</div>	
							<div class="act-address">地址：{{item.act_address}}</div>	
							<div class="act-button">
								<el-button type="primary" round @click="url('/detail?id=' + item.id)">围观详情</el-button>
							</div>
							<div class="act-view">
								<i class="el-icon-view"></i>{{item.act_view}}人次
							</div>
						</div>
					</div>
				</el-col>
				<el-empty description="暂无内容" v-if="!list.length"></el-empty>
		    </el-row>
		</div>

		<!-- 分页 -->
		<div class="page"  v-if="total">
			<el-pagination
				background
				layout="prev, pager, next"
				:total="total"
				:page-size="count"
				:current-page="page"
				@size-change="change2"
				@current-change="change2"
				@prev-click="change2"
				@next-click="change2"
			>
			</el-pagination>
		</div>

	</div>
</template>

<script>
	import {
		activity_cate,
		activity_list
	} from '@/api/activity.js';
	export default {
		name: 'indexActivity',
		data() {
			return {
				cate: [],
				list: [],
				current: 0,
				total:0,
				count:9,
				page:1,
			}
		},
		props: {
			keyword:'',
		},
		created() {
			this.get_data();
		},
		methods: {
			get_data() {
				activity_cate({}).then(res => {
					if (res.code == 1) {
						this.cate = res.data;
						this.get_list(res.data[0].id);
					}
				});
			},

			get_list(id,key) {
				activity_list({
					keyword: key?key:this.keyword,
					page: this.page,
					count: this.count,
					id: id
				}).then(res => {
					if (res.code == 1) {
						this.list = res.data.info?res.data.info:[];
						this.total = res.data.total?res.data.total:0;
					}
				});
			},

			change(index) {
				this.current = index;
				this.get_list(this.cate[index].id);
			},

			change2(e){
				this.page = e;
				this.get_list(this.cate[this.current].id);
			},

			url(path) {
				if (path.indexOf("http") != -1) {
					window.location.href = path;
				} else {
					this.$router.push(path);
				}
			},
		}
	}
</script>
<style scoped>
	.cate {
		width: 1300px;
		margin: 50px auto;
		border-bottom: 1px solid #a0ca32;
		text-align: center;
	}

	.cate-name {
		text-align: center;
		height: 50px;
		line-height: 50px;
		display: inline-block;
		padding: 0 50px;
		font-size: 22px;
		margin-bottom: -5px;
	}

	.cate-name:hover {
		cursor: pointer;
	}

	.active {
		font-weight: 800;
		border-bottom: 8px solid #a0ca32;
	}
	.cate-image{
		margin: 0 auto;
		margin-top: 50px;
		width: 1300px;
		margin-bottom: 50px;
	}
	.cate-image img{
		width: 1300px;
	}

	.act-list{
		width: 1300px;
		margin: 0 auto;
		margin-bottom: 50px;
	}
	.act-content{
		background: #fff;
		border-bottom-left-radius:20px;
		border-bottom-right-radius:20px;
		margin-bottom: 30px;
	}
    .act-image{
        overflow: hidden;
    }
	.act-image img{
        height: 200px;
	}
	.act-info{
		padding: 15px;
		min-height: 200px;
	}
	.act-name{
		line-height: 1.5;
		font-size: 16px;
		font-weight: 700;
		margin-bottom: 15px;
	}
	.act-time,.act-address{
		margin-top: 5px;
		font-size: 14px;
		color: #333;
	}
	.act-button{
		text-align: center;
	}
	.act-button button{
		background: #a0ca32;
		height: 40px;
		border-radius: 20px;
		border:none;
		width: 70%;
		color: #fff;
		margin-top: 20px;
	}
	.page{
		width: 1300px;
		margin: 0 auto;
		height: 100px;
		text-align: center;
	}
	/deep/ .el-pagination.is-background .btn-next, /deep/ .el-pagination.is-background  .btn-prev {
		background: #fff;
	}
	/deep/ .el-pagination.is-background .el-pager li{
		background: #fff;
	}
	/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
		background: #a0ca32;
	}
	/deep/ .el-pagination.is-background .el-pager li:not(.disabled):hover{
		color: #a0ca32;
	}
	.act-view{
		font-size: 14px;
		color: #666;
		margin-top: 15px;
	}
	.act-view i {
		margin-right: 10px;
	}
	/deep/ .act-content img{
		max-width: 100%!important;
		text-align: center!important;
	}
</style>
